import { clsx } from 'clsx';

import { formInputsDict } from '@monoimin/intl';

import { Icons } from '@monoimin/atoms';

import { getInputGrid, showByConditionalLogic } from '@monoimin/utils/helpers';

import type { InputProps } from '@monoimin/forms/gravity-form/types';

export const SelectInput = ({
  label,
  choices,
  adminLabel,
  isRequired,
  formValuesById,
  conditionalLogic,
  locale,
  customId,
  layoutGridColumnSpan = 12,
  classNames,
}: InputProps) => {
  if (!Array.isArray(choices)) return null;

  const show = conditionalLogic
    ? showByConditionalLogic({ conditionalLogic, formValuesById })
    : true;
  if (!show) return null;

  const gridColumn = getInputGrid(layoutGridColumnSpan);
  return (
    <div className={clsx(classNames?.container, gridColumn)}>
      <label className={clsx('text-black-500 mb-2.5 block', classNames?.label)}>
        {label}
      </label>

      <div
        className={clsx(
          'px-3.5 bg-white relative border border-line',
          classNames?.inputContainer
        )}
      >
        <select
          id={customId}
          name={adminLabel || customId}
          required={isRequired}
          className='w-full h-14 focus:outline-hidden appearance-none bg-transparent'
          defaultValue={formInputsDict[locale].select}
        >
          <option value={formInputsDict[locale].select} disabled>
            {formInputsDict[locale].select}
          </option>
          {choices
            .filter((choice) => choice.text)
            .map((choice) => {
              return (
                <option
                  className='text-body'
                  value={choice.value}
                  key={choice.text}
                >
                  {choice.text}
                </option>
              );
            })}
        </select>
        <div className='absolute h-full right-3 top-0 flex items-center'>
          <Icons icon='dropdown' className='' />
        </div>
      </div>
    </div>
  );
};
